import {Select, Tooltip, DatePicker} from 'antd';
import moment from 'moment';
import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconWrapper} from '../../../IconWrapper';

import dayjs, {Dayjs} from 'dayjs';

const {Option} = Select;
const {RangePicker} = DatePicker;

const dateOptions = [
  {
    label: 'Lifetime',
    value: 'lifetime',
  },
  {
    label: 'Last 30 days vs last previous 30 days',
    value: 'last_30_days_vs_prev_30_days',
    className: 'campaigns-page__last30vsprev30-option',
    tooltip: 'Last 30 days vs last previous 30 days',
  },
  {
    label: 'Last 7 days',
    value: 'last_7_days',
  },
  {
    label: 'Last 30 days',
    value: 'last_30_days',
  },
  {
    label: 'Last 3 Months',
    value: 'last_3_months',
  },
  {
    label: 'Last 6 months',
    value: 'last_6_months',
  },
  {
    label: 'Last 12 months',
    value: 'last_12_months',
  },
  {
    label: 'Custom',
    value: 'custom',
  }
];

export const DateFilter = ({
  handleChange,
  filters,
  updateGraph,
  campaignsToRequest,
  filterCampaigns,
}) => {
  const [showCustom, setShowCustom] = React.useState(false);
  const [showDatesSelect, setShowDatesSelect] = React.useState(false);

  const lastTwoMonthRange: [Dayjs, Dayjs] = [dayjs().subtract(1, 'months'), dayjs()];
  const disableFutureDates = currentDate => currentDate && currentDate >= moment().endOf('day');

  const onChange = date => {
    if (date === 'custom') {
      setShowCustom(true);
      return;
    }
    setShowCustom(false);
    handleChange(date);
  };

  const customDates = arg => {
    setShowCustom(false);
    let [start, end] = arg;
    start = start.format('YYYY-MM-DD');
    end = end.format('YYYY-MM-DD');
    filterCampaigns({
      ...filters,
      date: `${start} - ${end}`,
      date_range_start: start,
      date_range_end: end,
    });
    updateGraph(campaignsToRequest);
  };
  return (
    <>
      <RangePicker
        className="custom-range__datepicker"
        open={showCustom}
        onChange={customDates}
        defaultValue={lastTwoMonthRange}
        disabledDate={disableFutureDates}
      />
      <Select
        open={showDatesSelect}
        value={filters.date}
        style={{marginLeft: 10}}
        className="connections-page__filter-input"
        onDropdownVisibleChange={open => setShowDatesSelect(open)}
        onChange={onChange}
        prefix={
          <IconWrapper>
            <FontAwesomeIcon icon={['fas', 'clock']} />
          </IconWrapper>
        }
      >
        {dateOptions.map(item =>
          item.tooltip ? (
            <Option className={item.className} key={item.value}>
              <Tooltip title={item.tooltip}>{item.label}</Tooltip>
            </Option>
          ) : (
            <Option className={item.className} key={item.value}>
              {item.label}
            </Option>
          )
        )}
      </Select>
    </>
  );
};
